/**
 * FikoKesim Dialog — Lazer/Plazma/Su Jeti kesim süre & maliyet UI
 * Proses seç → çevre+delme → süre+maliyet. Modelden çevre/delik otomatik.
 */
import { Component, Input, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import * as THREE from 'three';
import { kesimHesapla, KESIM_PROSES, KesimProses, KesimSonuc } from './FikoKesim';
import { ozellikleriTani } from '../fiko-feature-tani/FikoFeatureTani';

@Component({
  selector: 'fikoyt-kesim',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, FormsModule],
  template: `
  <div class="ks">
    <div class="ks-proses">
      @for (p of prosesler; track p) {
        <button class="ks-pb" [class.aktif]="proses===p" (click)="prosesSec(p)">{{ KP[p].ad }}</button>
      }
    </div>
    <div class="ks-grid">
      <div class="ks-in"><label>Çevre (mm)</label><input type="number" [(ngModel)]="cevre" (ngModelChange)="hesapla()" min="0"></div>
      <div class="ks-in"><label>Delme adedi</label><input type="number" [(ngModel)]="delme" (ngModelChange)="hesapla()" min="0"></div>
      <div class="ks-in"><label>Hız mm/dk</label><input type="number" [(ngModel)]="hiz" (ngModelChange)="hesapla()" min="1"></div>
      <div class="ks-in"><label>Delme sn</label><input type="number" [(ngModel)]="delmeSn" (ngModelChange)="hesapla()" min="0" step="0.1"></div>
      <div class="ks-in"><label>Saat ₺</label><input type="number" [(ngModel)]="saat" (ngModelChange)="hesapla()" min="0"></div>
      <div class="ks-in"><label>Gaz ₺/dk</label><input type="number" [(ngModel)]="gaz" (ngModelChange)="hesapla()" min="0"></div>
      <div class="ks-in"><label>Adet</label><input type="number" [(ngModel)]="adet" (ngModelChange)="hesapla()" min="1"></div>
    </div>
    <button class="ks-mini" (click)="modeldenAl()">⊕ Modelden Çevre/Delik Al</button>

    @if (sonuc) {
      <div class="ks-sonuc">
        <div class="ks-r"><span>Kesim süresi</span><b>{{ f(sonuc.kesimSureDk,2) }} dk</b></div>
        <div class="ks-r"><span>Delme süresi</span><b>{{ f(sonuc.delmeSureDk,2) }} dk</b></div>
        <div class="ks-r alt"><span>Toplam süre / parça</span><b>{{ f(sonuc.toplamSureDk,2) }} dk</b></div>
        <div class="ks-r"><span>İşçilik</span><b>{{ f(sonuc.isciMaliyet) }} ₺</b></div>
        <div class="ks-r"><span>Gaz/sarf</span><b>{{ f(sonuc.gazMaliyet) }} ₺</b></div>
        <div class="ks-r vurgu"><span>Birim maliyet</span><b>{{ f(sonuc.birimMaliyet) }} ₺</b></div>
        <div class="ks-r toplam"><span>TOPLAM ({{ adet }} ad)</span><b>{{ f(sonuc.toplamMaliyet) }} ₺</b></div>
      </div>
    }
    @if (hata) { <div class="ks-hata">{{ hata }}</div> }
  </div>
  `,
  styles: [`
    .ks { padding:10px; min-width:300px; max-width:340px; font-size:11px; color:#e6f6ff;
      background:linear-gradient(180deg,rgba(0,40,60,.96),rgba(0,18,36,.98)); border-radius:6px; }
    .ks-proses { display:flex; gap:5px; margin-bottom:8px; }
    .ks-pb { flex:1; padding:6px; background:rgba(0,60,80,.6); border:1px solid rgba(0,200,220,.35); color:#bff; border-radius:5px; cursor:pointer; font-size:11px; }
    .ks-pb.aktif { background:linear-gradient(90deg,#e67e22,#f39c12); color:#fff; border:none; font-weight:600; }
    .ks-grid { display:grid; grid-template-columns:1fr 1fr 1fr; gap:5px; margin-bottom:6px; }
    .ks-in { display:flex; flex-direction:column; gap:2px; }
    .ks-in label { font-size:9px; color:#5fd9f5; }
    .ks-in input { background:rgba(0,60,80,.8); border:1px solid rgba(0,200,220,.35); color:#fff; padding:4px; border-radius:4px; font-size:10px; outline:none; box-sizing:border-box; }
    .ks-mini { width:100%; background:rgba(0,90,110,.6); border:1px solid rgba(0,200,220,.4); color:#bdf; border-radius:4px; padding:5px; font-size:10px; cursor:pointer; }
    .ks-mini:hover { background:rgba(0,130,160,.8); }
    .ks-sonuc { margin-top:10px; background:rgba(0,0,0,.35); border:1px solid rgba(0,200,220,.3); border-radius:5px; padding:8px; }
    .ks-r { display:flex; justify-content:space-between; padding:3px 0; border-bottom:1px solid rgba(0,200,220,.12); }
    .ks-r span { color:#9fe8f7; }
    .ks-r.alt { border-top:1px dashed rgba(0,200,220,.3); }
    .ks-r.vurgu { background:rgba(0,200,120,.16); margin:4px -8px; padding:6px 8px; border:none; } .ks-r.vurgu b { color:#7dffc0; font-size:13px; }
    .ks-r.toplam { background:rgba(255,180,0,.14); margin:2px -8px -2px; padding:6px 8px; border:none; } .ks-r.toplam b { color:#ffd76a; font-size:13px; }
    .ks-hata { margin-top:8px; padding:6px; background:rgba(255,50,50,.2); border:1px solid rgba(255,100,100,.4); border-radius:4px; color:#ff9a9a; text-align:center; }
  `]
})
export class FikoKesimComponent {
  @Input() anaGosterim: any = null;
  @Input() pencere: any;
  @Input() ayarlar: any = {};
  @Input() modelleme: any = null;

  KP = KESIM_PROSES;
  prosesler: KesimProses[] = ['lazer', 'plazma', 'sujeti'];
  proses: KesimProses = 'lazer';
  cevre = 1000; delme = 1; hiz = 3000; delmeSn = 0.8; saat = 900; gaz = 4; adet = 1;
  sonuc: KesimSonuc | null = null;
  hata: string | null = null;

  constructor(private cd: ChangeDetectorRef) { this.sonuc = this.hesaplaInt(); }

  prosesSec(p: KesimProses): void { this.proses = p; const k = KESIM_PROSES[p]; this.hiz = k.hiz; this.delmeSn = k.delme; this.gaz = k.gazDk; this.hesapla(); }

  private hesaplaInt(): KesimSonuc {
    return kesimHesapla({ cevreUzunlukMm: this.cevre, delmeSayisi: this.delme, kesimHizMmDk: this.hiz, delmeSureSn: this.delmeSn, saatUcreti: this.saat, gazUcretDk: this.gaz, adet: this.adet });
  }
  hesapla(): void { this.sonuc = this.hesaplaInt(); this.cd.detectChanges(); }

  modeldenAl(): void {
    const mesh = this.modelleme?.govdeMesh || this.anaGosterim?.modelleme?.govdeMesh;
    if (!mesh) { this.hata = 'Aktif model yok'; this.cd.detectChanges(); return; }
    const b = new THREE.Box3().setFromObject(mesh); const s = new THREE.Vector3(); b.getSize(s);
    let cevre = 2 * (s.x + s.y);   // dış kontur ≈ bbox perimetre
    let delme = 1;                  // dış kontur için 1 pierce
    try { for (const o of ozellikleriTani(mesh)) if (o.tip === 'delik' && o.cap) { cevre += Math.PI * o.cap; delme++; } } catch { }
    this.cevre = Math.round(cevre); this.delme = delme; this.hata = null; this.hesapla();
  }

  f(v: number, d = 2): string { return (v ?? 0).toLocaleString('tr-TR', { minimumFractionDigits: 0, maximumFractionDigits: d }); }
}
